/**
 * SWAYM Motion Core (motion.js)
 * Initializes GSAP, ScrollTrigger, and Lenis smooth scrolling.
 * Exposes reusable motion utility helpers for component developers.
 */

(function () {
  // Safe global namespace initialization
  window.SwaymMotion = window.SwaymMotion || {};

  document.addEventListener('DOMContentLoaded', () => {
    // 1. Detect and register GSAP and ScrollTrigger
    if (typeof gsap === 'undefined') {
      console.warn('SwaymMotion: GSAP is not loaded. Motion features deactivated.');
      return;
    }

    if (typeof ScrollTrigger !== 'undefined') {
      gsap.registerPlugin(ScrollTrigger);
    } else {
      console.warn('SwaymMotion: ScrollTrigger not found.');
    }

    // 2. Default browser scroll (Lenis smooth scroll disabled for native feel)
    let lenisInstance = null;
    window.SwaymMotion.lenis = null;

    // 3. Expose Reusable Motion Utility Helpers
    window.SwaymMotion.helpers = {
      /**
       * Returns the active Lenis scroll instance.
       */
      getLenis: () => lenisInstance,

      /**
       * Safely creates a scroll-triggered animation container.
       * @param {Element|string} triggerElement - Element to trigger scroll trigger
       * @param {object} vars - GSAP animation properties
       * @param {object} scrollTriggerVars - ScrollTrigger specific configuration overrides
       */
      createScrollAnimation: (triggerElement, vars, scrollTriggerVars = {}) => {
        const defaultTrigger = {
          trigger: triggerElement,
          start: 'top 80%',
          end: 'bottom 20%',
          toggleActions: 'play none none reverse',
        };

        return gsap.to(triggerElement, {
          ...vars,
          scrollTrigger: {
            ...defaultTrigger,
            ...scrollTriggerVars,
          },
        });
      },

      /**
       * Programmatically scrolls to a target selector/element using smooth scroll.
       * @param {string|Element} target - Selector string or DOM element
       * @param {object} options - Lenis scroll configuration options
       */
      scrollTo: (target, options = {}) => {
        const el = typeof target === 'string' ? document.querySelector(target) : target;
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start', ...options });
        }
      }
    };
  });
})();
